import { resourcePath } from '@gameday/utils/resource-path';
import { getLanguagePath } from '@gameday/utils/languageHelpers';
export const RATIO = '16:9';
const baseWidth = 1200;
const baseHeight = 675;

export const formatInstructionSet = {
    '1x': `q_auto:good,w_${baseWidth},ar_${RATIO},c_fill,g_auto,f_jpg`,
    '2x': `q_40,w_${baseWidth * 2},ar_${RATIO},c_fill,g_auto,f_jpg`,
    '3x': `q_20,w_${baseWidth * 3},ar_${RATIO},c_fill,g_auto,f_jpg`
};

const normalizationHelper = ({ id, title, playbacks, srcSet, gamePk, language, description, duration }) => {
    let shareUrl;

    if (gamePk && language) {
        shareUrl = resourcePath.get('videoShareUrl', {
            gamePk,
            languagePath: getLanguagePath(language),
            slug: id
        });
    }

    return {
        id,
        title,
        description,
        duration,
        playbacks,
        authflow: false,
        content_id: id,
        shareUrl,
        image: {
            altText: title,
            cuts: [
                {
                    aspectRatio: RATIO,
                    width: baseWidth,
                    height: baseHeight,
                    src: srcSet['1x'],
                    at2x: srcSet['2x'],
                    at3x: srcSet['3x']
                }
            ]
        }
    };
};

export default normalizationHelper;
